// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts_SEjuG {
  position: absolute;
  bottom: 100%;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
  background-color: var(--white-color);
  border: 1px solid var(--ececf1-border);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  z-index: 99;
  .contact_cDIGR,.asset_pHIPw {
    display: flex;
    align-items: center;
    display: flex;
    gap: 10px;
    padding: 5px;
    cursor: pointer;
    img {
      border-radius: 999px;
      -webkit-border-radius: 999px;
      -moz-border-radius: 999px;
      -ms-border-radius: 999px;
      -o-border-radius: 999px;
      object-fit: cover;
    }
    p {
      color: #09090b;
    }
    span {
      color: #666666;
      font-size: 13px;
    }
  }

  .chatCard_dkdtB{
    border-radius: 8px;
    background-color: var(--white-background);
           p {
      margin: 0;
      font-size: 14px;
      font-weight: bold;
           }
    span {
      color: #666666;
      font-size: 13px;
    }
}
  .newContactInfoClient_YLafT {
    background-color: var(--f5-background);
    padding: 10px;
    padding-left: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
  }
}



.chatCard_dkdtB:hover{
 background-color: var(--f5-background);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ContactsPopup/ContactsPopup.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;EACtB,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,eAAe;IACf;MACE,oBAAoB;MACpB,4BAA4B;MAC5B,yBAAyB;MACzB,wBAAwB;MACxB,uBAAuB;MACvB,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,cAAc;MACd,eAAe;IACjB;EACF;;EAEA;IACE,kBAAkB;IAClB,yCAAyC;WAClC;MACL,SAAS;MACT,eAAe;MACf,iBAAiB;WACZ;IACP;MACE,cAAc;MACd,eAAe;IACjB;AACJ;EACE;IACE,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;AACF;;;;AAIA;CACC,sCAAsC;AACvC","sourcesContent":[".contacts {\n  position: absolute;\n  bottom: 100%;\n  width: 100%;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-sizing: border-box;\n  background-color: var(--white-color);\n  border: 1px solid var(--ececf1-border);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  z-index: 99;\n  .contact,.asset {\n    display: flex;\n    align-items: center;\n    display: flex;\n    gap: 10px;\n    padding: 5px;\n    cursor: pointer;\n    img {\n      border-radius: 999px;\n      -webkit-border-radius: 999px;\n      -moz-border-radius: 999px;\n      -ms-border-radius: 999px;\n      -o-border-radius: 999px;\n      object-fit: cover;\n    }\n    p {\n      color: #09090b;\n    }\n    span {\n      color: #666666;\n      font-size: 13px;\n    }\n  }\n\n  .chatCard{\n    border-radius: 8px;\n    background-color: var(--white-background);\n           p {\n      margin: 0;\n      font-size: 14px;\n      font-weight: bold;\n           }\n    span {\n      color: #666666;\n      font-size: 13px;\n    }\n}\n  .newContactInfoClient {\n    background-color: var(--f5-background);\n    padding: 10px;\n    padding-left: 20px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n}\n\n\n\n.chatCard:hover{\n background-color: var(--f5-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contacts": `contacts_SEjuG`,
	"contact": `contact_cDIGR`,
	"asset": `asset_pHIPw`,
	"chatCard": `chatCard_dkdtB`,
	"newContactInfoClient": `newContactInfoClient_YLafT`
};
export default ___CSS_LOADER_EXPORT___;
